/* 
  Senior Software Engineer Note: 
  This file has been updated to support dynamic Tax Categories and Encashment Limits.
  Logic: 
  - TaxExemptLimit: The "Shield". First X days of encashment are non-taxable.
  - TaxCategory: Determines if the amount falls under De Minimis (1), 90k Ceiling (2), or Fully Taxable (3).
*/

import React, { useState, useEffect, useCallback } from "react";
import axios from '../../api/apiClient';

import {
  CreateTableNew as CreateTable,
  SearchBar,
  Button,
  GeneralMessage,
  useGeneralMessage
} from '../../common/APICommon';
import { SetAuditTrail, SetAuditTrailBulk } from './../Reports/AuditTrailReportEmployeeSetup';
import {
  CheckInput,
  Input,
  NumberInput // ADDED: Using specialized number input
} from '../../common/Input';
import { Select } from '../../common/Select'; // ADDED: Using the reusable Select component
import { token, domain } from '../Security';
import { LoadingSpinner } from '../../common/Loading';
// icon
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from '@mui/icons-material/Edit';
import LeaveTypePage from "../../v2/pages/Maintenance/LeaveTypePage";

function LeaveTypes({ user, userAccess, isHideSideMenu }) {

  return (
    <LeaveTypePage user={user} userAccess={userAccess} isHideSideMenu={isHideSideMenu}/>
  );
}

export default LeaveTypes;